import React from 'react'

import { Skeleton } from '@mui/material'
import { useCustomerContactsQuota } from 'features/customers/hooks/useCustomerContactsQuota'

import QuotaUsage from 'components/_base/QuotaUsage'

import UsageUnavailable from './UsageUnavailable'

const CustomerContactsQuotaLimit = () => {
  const { data: quota, isPending, isError } = useCustomerContactsQuota()

  if (isPending) {
    return <Skeleton variant="text" width={85} />
  }

  if (isError) {
    return <UsageUnavailable />
  }

  return <QuotaUsage quota={quota?.total} usage={quota?.used} />
}

export default CustomerContactsQuotaLimit
